export const EDIT = 1;
export const ADD = 2;
export const VIEW = 3;
